<template>
    <div class="team-profile-details">
        <base-header class="pb-6">
            <b-row align-v="center" class="py-2" v-if="current_team">
                <b-col md="3" lg="6" cols="auto">
                    <router-link :to="'/hubProfileDetails/'+current_team.hub.hub_id" class="text-primary">
                        <b-icon icon="chevron-left"></b-icon>
                        Hub Overview
                    </router-link>
                </b-col>
                <b-col md="9" lg="6" cols="12" class="text-right ">
                    <b-button-group class="btn-group-header mx-2">
                        <b-button size="sm" variant="light" class="btn-incharge" disabled>Hub Manager</b-button>
                        <b-button class="btn-incharge text-dark" size="sm" variant="light" disabled>{{ current_team.hub.hub_manager.name }}</b-button>
                    </b-button-group>
                    <b-button size="sm" v-show="backButton" variant="primary" icon @click="close()">
                        <span class="btn-inner--text">Back / Close</span>
                    </b-button>
                    <el-dropdown trigger="click" style="cursor: pointer">
                        <b class="el-dropdown-link">
                            <b-icon icon="three-dots-vertical"></b-icon>
                        </b>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="$refs.drawer_hub_commission_settings.viewHubCommissionSettings">Commission Settings</el-dropdown-item>
                            <!-- <el-dropdown-item @click.native="underDevelopment">Commission Settings</el-dropdown-item> -->
                            <el-dropdown-item>View Report</el-dropdown-item>
                            <el-dropdown-item class="text-danger">Delete Hub</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <b-row>
                <b-col cols="12" lg="3">
                    <team-biodata ></team-biodata>
                    <hub-pool :date_picked="date_picked"></hub-pool>
                    <hub-payout :date_picked="date_picked"></hub-payout>
                </b-col>
                 <b-col cols="12" lg="9">
                    <b-row>
                        <b-col xl="8">
                            <div class="text-right mb-4">
                                <el-date-picker
                                    v-model="date_picked"
                                    type="daterange"
                                    align="right"
                                    unlink-panels
                                    range-separator="To"
                                    start-placeholder="Start date"
                                    end-placeholder="End date"
                                    value-format="yyyy-MM-dd"
                                    @change="updateDatePicked"
                                    :picker-options="pickerOptions">
                                </el-date-picker>
                            </div>
                            <cases-card :current_team="current_team"></cases-card>
                            <hub-sales-performance></hub-sales-performance>
                            <total-pending-cases v-if="current_team" :hub_id="current_team.hub.hub_id"></total-pending-cases>
                            <top-product-categories></top-product-categories>
                        </b-col>
                        <b-col xl="4">
                            <hub-kpi-progress :current_name="current_name"></hub-kpi-progress>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>

        <DrawerHubDirectPayoutSettings ref="drawer_hub_commission_settings"></DrawerHubDirectPayoutSettings>

    </div>
</template>
<script>
import { DropdownMenu, DropdownItem, Dropdown, DatePicker } from 'element-ui'
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import TeamBiodata from '@/views/Commission/Hub/HubProfile/LeftProfileDetails/TeamBiodata'
import HubKpiProgress from '@/views/Commission/Hub/HubProfile/LeftProfileDetails/HubKpiProgress'
import CasesCard from '@/views/Commission/Hub/HubProfile/CenterProfileDetails/CasesCard'
import HubSalesPerformance from '@/views/Commission/Hub/HubProfile/CenterProfileDetails/HubSalesPerformance'
import TotalPendingCases from '@/views/Commission/Hub/HubProfile/CenterProfileDetails/TotalPendingCases'
import TopProductCategories from '@/views/Commission/Hub/HubProfile/CenterProfileDetails/TopProductCategories'
import HubPool from '@/views/Commission/Hub/HubProfile/RightProfileDetails/HubPool'
import HubPayout from '@/views/Commission/Hub/HubProfile/RightProfileDetails/HubPayout'
import { mapActions, mapState } from 'pinia'
import { useHubStore } from '@/stores/hubStore'
import { notifyFunctionMixin,axios,services,getHeader,swal } from '@/assets/js/httpImports.js'
import DrawerHubDirectPayoutSettings from '@/views/Commission/Hub/HubProfile/OffCanvasDetails/DrawerHubCommissionSettings/DrawerHubCommissionSettings'

export default {
    mixins: [notifyFunctionMixin],
    components: {
        RouteBreadCrumb,
        TeamBiodata,
        HubKpiProgress,
        CasesCard,
        HubSalesPerformance,
        TotalPendingCases,
        TopProductCategories,
        HubPool,
        HubPayout,
        DrawerHubDirectPayoutSettings,
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
        [DatePicker.name]: DatePicker,
    },
    data() {
        return {
            hub: null,
            backButton: true,
            pickerOptions: {
                shortcuts: [{
                    text: 'Last week',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: 'Last month',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: 'Last 3 months',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
            date_picked: '',
            current_name: '',
        };
    },
    watch: {
        current_team: {
            immediate: true, // Trigger the watcher immediately
            handler(newCurrentTeam) {
                if (newCurrentTeam) {
                    this.current_name = newCurrentTeam.team_leader.name;
                }
            },
        },
    },
    async created() {
        const currentDate = new Date();
        const firstDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
        firstDayOfMonth.setDate(firstDayOfMonth.getDate() + 1);

        this.date_picked = [
            firstDayOfMonth.toISOString().split('T')[0], // First day of the month
            currentDate.toISOString().split('T')[0]      // Current date
        ];

        await this.updateDatePicked();

        await this.getHubTeams(this.$route.params.hub_team_id)

        if(!this.current_team){
            this.$router.push({ name: 'NotFound' })
        }

        if(this.$route.params.token)
        {
            this.backButton = true;
        }
    },
    computed: {
        ...mapState(useHubStore,['current_team']),
    },
    methods: {
        close() {
            if(this.$route.params.token)
            {
                // window.location.href = "https://sas.imortgage2u.com/portal/initialSettlement/proposal/"+this.$route.params.proposal_id;
                window.history.back();
                window.close();
            }
            else
            {
                this.$router.back();
            }
        },
        async updateDatePicked() {
            useHubStore().setDatePicked(this.date_picked);
            await this.getHubTeams(this.$route.params.hub_team_id);
        },
        ...mapActions(useHubStore,['getHubTeams']),
    }
}
</script>